import { useRef } from "react";
import CountUp from "react-countup";
import { Props_SnippetStatistics } from "./Statistics.props";

const SnippetStatistics = (props: Props_SnippetStatistics) => {
    const { heading, statistics_layout, repeatable_entry } = props;
    const { background_image, overlay_color, text_color, text_size } = statistics_layout;

    const sectionRef = useRef(null);

    const extractNumber = (str: string): number => {
        const match = str.match(/[\d.]+/);
        return match ? parseFloat(match[0]) : 0;
    };

    const extractParts = (str: string): { prefix: string; suffix: string; decimals: number } => {
        const match = str.match(/^(.*?)([\d.]+)(.*)$/);
        if (!match) return { prefix: '', suffix: '', decimals: 0 };
        
        const numericPart = match[2];
        const decimals = numericPart.includes('.') ? numericPart.split('.')[1]?.length || 0 : 0;
        
        return {
            prefix: match[1] || '',
            suffix: match[3] || '',
            decimals
        };
    };

    const containerClasses = `snippet-statistics snippet-statistics__background-color--${overlay_color?.value?.replace(' ', '-')} snippet-statistics__text-color--${text_color?.value?.replace(' ', '-')}`;

    const baseDelay = 0.5;
    const delayIncrement = 0.2;

    return (
        <section className={containerClasses} ref={sectionRef}>
            <div className="snippet-statistics__container">
                <h2 className={`snippet-statistics__heading ${heading.visibility?.value ? '' : 'snippet-statistics__heading--hidden'}`}>
                    {heading.content?.value}
                </h2>
                <div className="snippet-statistics__container-entries">
                    {repeatable_entry.map((entry, index: number) => {
                        const numberPart = entry.number?.value || '';
                        const suffixPart = entry.suffix?.value || '';
                        const fullString = numberPart + suffixPart;
                        const targetValue = extractNumber(fullString);
                        const { prefix, suffix, decimals } = extractParts(fullString);
                        const delay = baseDelay + (index * delayIncrement);

                        return (
                            <div key={index} className="snippet-statistics__entry">
                                <span
                                    className={`snippet-statistics__entry-number snippet-statistics__entry-number--${text_size?.value}`}
                                >
                                    <CountUp
                                        start={0}
                                        end={targetValue}
                                        duration={2}
                                        delay={delay}
                                        decimals={decimals}
                                        prefix={prefix}
                                        suffix={suffix}
                                        enableScrollSpy
                                        scrollSpyOnce
                                        scrollSpyDelay={0}
                                    />
                                </span>
                                <span className="snippet-statistics__entry-description">
                                    {entry.description?.value}
                                </span>
                            </div>
                        );
                    })}
                </div>
            </div>
            {background_image?.value && (
                <div 
                    className="snippet-statistics__background-image" 
                    style={{ backgroundImage: `url(${background_image.value})` }}
                />
            )}
        </section>
    );
};

export default SnippetStatistics;